import { ArrowRightIcon, Body, Button, Headline, InboxIcon, ParcelsIcon } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router'

import { ButtonContainer, ContentSection, MinYSpacingWrapper, PostiPageFooter } from '../../components'
import { ResponsiveBody } from '../../components/typography/ResponsiveBody'
import { ResponsiveHeadline } from '../../components/typography/ResponsiveHeadline'
import Localization from '../../locales'
import { serviceAdapter } from '../../service/serviceAdapter'
import { StoreContext } from '../../store'
import { ExitRegistrationModal } from '../../views/registration/components/ExitRegistrationModal'
import { IconAndText, IconBulletList, TextContainer } from './registration.styles'

const iconProps = {
  width: '24px',
  height: '24px',
  'aria-hidden': true,
}

interface IProps {
  proceed: () => void
  hasSignoutButton?: boolean
}

type Props = RouteComponentProps & IProps

const BeforeComponent: React.FC<Props> = ({ proceed, hasSignoutButton }) => {
  const { t } = useTranslation()
  const { layoutStore } = useContext(StoreContext)
  const [exitModalOpen, setExitModalOpen] = useState(false)

  const onLogout = (e: any) => {
    e.preventDefault()
    setExitModalOpen(true)
  }

  return (
    <MinYSpacingWrapper>
      <TextContainer>
        <ResponsiveHeadline as="h1">{t('registration.before.title1')}</ResponsiveHeadline>
        <ContentSection>
          <ResponsiveBody>{t('registration.before.body1')}</ResponsiveBody>
          <ResponsiveBody>{t('registration.before.body1b')}</ResponsiveBody>
        </ContentSection>
        <IconBulletList>
          <IconAndText>
            <InboxIcon {...iconProps} />
            <ResponsiveBody>{t('registration.before.bullets.omaPosti')}</ResponsiveBody>
          </IconAndText>
          <IconAndText>
            <ParcelsIcon {...iconProps} />
            <ResponsiveBody>{t('registration.before.bullets.pickupPoint')}</ResponsiveBody>
          </IconAndText>
        </IconBulletList>
        <ContentSection>
          <Headline size="Eight">{t('registration.before.title2')}</Headline>
          <ResponsiveBody>{t('registration.before.body2')}</ResponsiveBody>
        </ContentSection>
        <ButtonContainer>
          {hasSignoutButton && (
            <Button size="sm" id="button_exit" contentMode="secondary" onClick={onLogout}>
              {t('registration.buttons.exit')}
            </Button>
          )}
          {!hasSignoutButton && (
            <Button
              size="sm"
              id="button_cancel"
              contentMode="secondary"
              onClick={() => (location.href = `https://posti.fi/${Localization.CurrentLocale}`)}
            >
              {t('general.cancel')}
            </Button>
          )}
          <Button
            size="sm"
            id="button_proceed_to_create"
            contentMode="primary"
            onClick={proceed}
            hasBackground
            rightIcon={layoutStore.isDesktop ? ArrowRightIcon : undefined}
          >
            {t('registration.buttons.proceedToCreate')}
          </Button>
        </ButtonContainer>
        <ExitRegistrationModal
          isOpen={exitModalOpen}
          title={t('registration.exitModal.title')}
          onCancel={() => setExitModalOpen(false)}
          onConfirm={serviceAdapter.handleLogOut}
        >
          <Body size={'Three'}>{t('registration.exitModal.text')}</Body>
        </ExitRegistrationModal>
        <PostiPageFooter showCookiePreferences />
      </TextContainer>
    </MinYSpacingWrapper>
  )
}

export const Before = withRouter(observer(BeforeComponent))
